var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { flattenItems } from '../legacy';
import { isAccordionOptionProps, isGroupOptionProps, isNextListOptionProps } from './typeGuards';
export function transformOptionsToItems(options) {
    return options.map(option => {
        if (isAccordionOptionProps(option) || isNextListOptionProps(option)) {
            const { description, option: contentOption, caption, options, value } = option, rest = __rest(option, ["description", "option", "caption", "options", "value"]);
            return Object.assign(Object.assign({ 'data-test-id': 'field-select__list-option-' + option.value }, rest), { id: value, content: { option: contentOption, caption, description }, items: transformOptionsToItems(options) });
        }
        if (isGroupOptionProps(option)) {
            const { options } = option, rest = __rest(option, ["options"]);
            return Object.assign(Object.assign({}, rest), { items: transformOptionsToItems(options) });
        }
        const _a = option, { description, option: contentOption, caption, value, appearance } = _a, rest = __rest(_a, ["description", "option", "caption", "value", "appearance"]);
        return Object.assign(Object.assign({ 'data-test-id': 'field-select__list-option-' + option.value }, rest), { id: value, appearance: appearance, content: { option: contentOption, caption, description } });
    });
}
export function findSelectedOption(items, value) {
    const flatten = flattenItems(items);
    if (!value) {
        return [undefined, undefined];
    }
    const foundItem = flatten.find(item => String(item.id) === String(value));
    const placeholderItem = { id: value, content: { option: String(value) } };
    return [foundItem, !foundItem ? placeholderItem : undefined];
}
export function findSelectedOptions(items, value) {
    const flatten = flattenItems(items);
    if (!value || !(value === null || value === void 0 ? void 0 : value.length)) {
        return [undefined, undefined];
    }
    let foundItems;
    let placeholderItems;
    value.forEach(value => {
        if (flatten) {
            const [found, placeholder] = findSelectedOption(flatten, value);
            if (found || foundItems) {
                foundItems = (foundItems !== null && foundItems !== void 0 ? foundItems : []).concat(found !== null && found !== void 0 ? found : []);
            }
            if (placeholder || placeholderItems) {
                placeholderItems = (placeholderItems !== null && placeholderItems !== void 0 ? placeholderItems : []).concat(placeholder !== null && placeholder !== void 0 ? placeholder : []);
            }
        }
    });
    return [foundItems, placeholderItems];
}
